var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullBox',[_c('MiddleBox',[_c('RetornoCampo',{attrs:{"campo":_vm.campo.confiabilidad}})],1),_c('MiddleBox',[_c('RetornoCampo',{attrs:{"campo":_vm.campo.riesgo}})],1),_c('FullBox',[_c('RetornoCampo',{attrs:{"campo":_vm.campo.observacion}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }